import { useFlags } from "@featbit/react-client-sdk";
import { flagDefaults } from "src/consts/flagDefaults";
import { FlagValue, Flags } from "src/consts/flags";

export function useFlag(
  flag: Flags,
  type: "boolean" | "number" | "object" = "boolean"
): boolean | number | object {
  const featbitFlags = useFlags() as Partial<Record<Flags, FlagValue>>;
  const value = featbitFlags[flag] ?? flagDefaults[flag];

  switch (type) {
    case "boolean":
      if (typeof value === "string") {
        return value === "true";
      }
      return Boolean(value);
    case "number":
      return Number(value);
    case "object":
    default:
      return value;
  }
}

export function useBooleanFlag(flag: Flags): boolean {
  return useFlag(flag, "boolean") as boolean;
}

export function useNumberFlag(flag: Flags): number {
  return useFlag(flag, "number") as number;
}

export function useObjectFlag<T extends Record<string, unknown>>(flag: Flags): T {
  return useFlag(flag, "object") as T;
}
